import helperStyles from "@src/components/helpers.module.scss";
import React from "react";

export const Paper: React.FC = () => {
	return (
		<div className={helperStyles.iconContainer}>
			<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
				<g fill="none" stroke="#A09FA7">
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="2"
						d="M10 9h4m-4 7h12m-12 4h12m-12 4h4m-6 5h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2"
					/>
					<circle cx="22" cy="9" r=".5" fill="currentColor" />
				</g>
			</svg>
		</div>
	);
};
